export default "__VITE_ASSET__CmDtkYFX__"